import { render, staticRenderFns } from "./MembershipChangeStatusIndividualCorporate.vue?vue&type=template&id=615cd96e&scoped=true&"
import script from "./MembershipChangeStatusIndividualCorporate.vue?vue&type=script&lang=js&"
export * from "./MembershipChangeStatusIndividualCorporate.vue?vue&type=script&lang=js&"
import style0 from "./MembershipChangeStatusIndividualCorporate.vue?vue&type=style&index=0&id=615cd96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615cd96e",
  null
  
)

export default component.exports